export class Visible{
    init(){

        var elem = $('.ex-text:not(.modal), .form');
        var self = this;

        self.checkIfVisible(elem);

        $(window).scroll(function() {
            self.checkIfVisible(elem);
        });
        this.delayShort($('.slider-numbers .slider__item'));
        this.delayShort($('.form--newsletter > *'));
    }
    checkIfVisible(elem){
        elem.each(function() {
            var $this = $(this),
                elemVisible = $this.visible(true, 'vertical');

            if(elemVisible){
                $this.addClass('on-screen', elemVisible);
                $this.data('fraction') != 'undefined' ? $this.trigger('click') : ''; 
                setTimeout(function() {
                    $this.addClass('triggered');
                }, 500);
            }
        });
    }
    delay(elem){
        elem.each(function(index) {
            $(this).css('transition-delay', (300+(150*index) + 'ms'));
        });
    }
    delayShort(elem){
        elem.each(function(index) {
            $(this).css('transition-delay', ((100*index) + 'ms'));
        });
    }
    delayShortWithClick(elem){
        elem.each(function(index) {
            $(this).css('transition-delay', ((100*index) + 'ms'));
        });
    }
}